<template>
  <div v-if="$store.state.languagePack !== {} && $store.state.siteSettings !== []" ref="footer" :class="['footer']">
    <div class="fixed-forgrid">
      <b-container fluid>
        <b-row class="footer-content ctrl-dir">
          <b-col cols="3">
            <div class="contact-items">
              <p class="contact-item"><i class="fa fa-map-marker-alt"></i> {{ address }}</p>
              <p class="contact-item"><i class="fa fa-phone" style="transform: rotateY(180deg)"></i> <a class="contact-item-link" :href="'tel:+' + phone">{{ phone }}</a></p>
              <p class="contact-item"><i class="fas fa-envelope"></i> <a class="contact-item-link" :href="'mailto:' + email">{{ email }}</a></p>
            </div>
          </b-col>
          <b-col cols="3"></b-col>
          <b-col cols="6">
            <div class="logo">
              <b-link v-if="logoUrl !== undefined" :to="navLinkPrefix + '/'">
                <img :src="host + logoUrl" :alt="'QazLatyn'">
              </b-link>
            </div>
            <div class="social-share-links">
              <b-link
                v-if="facebook !== '' && facebook !== undefined"
                :href="facebook" class="social-share-link"
                style="color: #4267b2;">
                <i class="fab fa-facebook-f"></i>
              </b-link>
              <b-link
                v-if="instagram !== '' && instagram !== undefined"
                :href="instagram" class="social-share-link"
                >
                <i
                  class="fab fa-instagram"
                  style="font-size: 15px; background: #d6249f; background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);color:#ffffff;"></i>
              </b-link>
              <b-link
                v-if="youtube !== '' && youtube !== undefined"
                :href="youtube" class="social-share-link"
                style="color:#ff0000;">
                <i class="fab fa-youtube"></i>
              </b-link>
              <b-link
                v-if="telegram !== '' && telegram !== undefined"
                :href="telegram" class="social-share-link"
                style="color:#2db9ff;">
                <i class="fab fa-telegram"></i>
              </b-link>
              <b-link
                v-if="vk !== '' && vk !== undefined"
                :href="vk" class="social-share-link"
                style="color: #5283b7;">
                <i class="fab fa-vk"></i>
              </b-link>
              <b-link
                v-if="twitter !== '' && twitter !== undefined"
                :href="twitter" class="social-share-link"
                style="color: #55acee;">
                <i class="fab fa-twitter"></i>
              </b-link>
            </div>
            <div class="report-error text-right operating-instructions">
              <strong @click="showOIsModal">{{ ls_OperatingInstructions }}</strong>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="footer-bottom">
      <div class="fixed-forgrid px-3">
        <span class="copyright" v-html="copyright"></span>
        <span class="report-error float-right">
          <strong>{{ ls_ReportError }}</strong> {{ ls_ReportErrorDescription }}
        </span>
      </div>
    </div>
    <b-modal ref="oisModal" size="lg" @show="playOIsVedio" @hide="pauseOIsVedio" hide-footer :title="ls_OperatingInstructions">
      <div class="d-block text-center video-container">
        <video ref="oisVedio" class="video" src="https://www.qazlatyn.kz/uploads/video/usingconverter.mp4" controls="controls">
          This browser is not support video!
        </video>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import "@/assets/js/reportSuggest.js";
export default {
  data() {
    return {
      footerPosition: "position-static"
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_ReportError() {
      return this.$store.state.languagePack.ls_ReportError;
    },
    ls_OperatingInstructions() {
      return this.$store.state.languagePack.ls_OperatingInstructions;
    },
    ls_ReportErrorDescription() {
      return this.$store.state.languagePack.ls_ReportErrorDescription;
    },
    facebook() {
      return this.$store.state.siteSettings.facebook;
    },
    instagram() {
      return this.$store.state.siteSettings.instagram;
    },
    youtube() {
      return this.$store.state.siteSettings.youtube;
    },
    vk() {
      return this.$store.state.siteSettings.vk;
    },
    twitter() {
      return this.$store.state.siteSettings.twitter;
    },
    telegram() {
      return this.$store.state.siteSettings.telegram;
    },
    email() {
      return this.$store.state.siteSettings.email;
    },
    phone() {
      return this.$store.state.siteSettings.phone;
    },
    address() {
      return this.$store.state.siteSettings.address;
    },
    copyright() {
      return this.$store.state.siteSettings.copyright;
    },
    logoUrl() {
      return this.$store.state.siteSettings.pcLogo;
    },
    navLinkPrefix() {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln
        : "";
    },

    routePath() {
      return this.$route.params.ln !== undefined
        ? this.$route.path.substring(
            this.$route.path.substring(1).indexOf("/") + 1
          )
        : this.$route.path;
    }
  },

  methods: {
    showOIsModal() {
      this.$refs.oisModal.show();
    },
    playOIsVedio() {
      let video = this.$refs.oisVedio;
      if (!video) return;
      video.addEventListener(
        "load",
          function() {
            video.play();
          },
          false
      );
      video.pause();
      video.play();
    },
    pauseOIsVedio() {
      let video = this.$refs.oisVedio;
      if (!video) return;
      video.pause();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/common.scss";

.footer {
  position: absolute;
  border-top: 1px solid #b0b2b4;
  background-color: #008496;
  right: 0;
  bottom: 0;
  left: 0;

  .footer-bottom {
    font-size: 12px;
    color: #c8c9ca;
    background-color:#016f7e;
    padding: 1rem;

    .copyright {}

    .using-converter {
      float: right;
    }
  }

  .footer-content {
    padding: 40px 0;

    .logo {
      display: none;
      padding: 1rem 1.5rem;
      background-color: #e1e1e1;

      img {
        height: 3.25rem;
      }
    }

    .contact-items {
      .contact-item {
        margin-bottom: 0.25rem;
        color: #d3d3d3;
        font-size: 14px;
        font-weight: 500;
        line-height: 27px;

        i {
          margin-right: 9px;
          color: #ffffff;
        }
      }
    }

    .social-share-links {
      display: flex;
      height: 100%;
      align-items: flex-start;
      justify-content: flex-end;

      .social-share-link {
        text-decoration: none;
        margin: 0.25rem;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        background-color: #ffffff;
        
        border-radius: 50%;
        border: 1px solid #008496;
        font-size: 1rem;
        color: #008496;
        transition: all 100ms ease-in-out;

        &:hover {
          box-shadow: 0 0 0 1px rgba(0,0,0,0.04), 0 4px 8px 0 rgba(0,0,0,0.20);
        }
      }
    }
  }
}

.video-container {
  margin: -15px;

  .video {
    max-width: 100%;
  }
}

/* RTL */

.rtl-layout .footer {

  .social-share-links {
    justify-content: flex-start;
  }

  .contact-items {
    .contact-item {
      text-align: right;
      direction: rtl;

      i {
        margin-right: 0;
        margin-left: 3px;
        transform: rotate(0deg) !important;
      }
    }
  }

  .footer-bottom {
    direction: rtl;
  }
}
</style>

<style>
.contact-items .contact-item i {
  margin-right: 6px;
  color: #f6f6f6;
}
.contact-items .contact-item .contact-item-link {
  color: #d3d3d3 !important;
}


.report-error {
  font-size: 14px;
  color: #d3d3d3;
}
.operating-instructions > strong {
  color: #ffcc00 !important;
  cursor: pointer;
}
.report-error strong {
  color: #ffffff;
}

/* RTL */
.rtl-layout .report-error {
  direction: rtl !important;
  text-align: left !important;
}
</style>
